<template>
  <div class="CovidEmployeurs" >
    <formTitleComponent />
      <div class="container">
        <div class="form_div">
          <div class="form_content">
            <h1 class="form_div_title text-center">Mentions légales et Cookies</h1>
            <p>
              Ces mentions peuvent être modifiées à tout moment et sans préavis, nous vous engageons à les consulter régulièrement.
            </p>
            <h2>
              Propriétaire et éditeur du site
            </h2>
            <p>
              Ce site est édité par :<br>
              AUDAS PRO<br>
              Adresse de l’établissement principal : 74 rue Jean Bleuzen, 92170 Vanves.<br>
              Directeur de la publication : Monsieur Thierry Teboul, en sa qualité de Président de l’association Audas Pro,<br>
              Ci-après dénommée « l’Éditeur ».
            </p>

            <h2>
              Hébergement
            </h2>
            <p>
              Le site est hébergé chez OVH SAS<br>
              Siège social : 2 rue Kellermann - 59100 Roubaix - France<br>
              N° SIREN : 424 761 419 R.C.S Lille
            </p>

            <h2>
              Informations et responsabilité
            </h2>
            <p>
              L’Editeur met tout en œuvre afin d’assurer l'exactitude et la mise à jour des informations diffusées
              lors de leur mise en ligne. Il se réserve le droit de modifier, de corriger ou de supprimer
              à tout moment et sans préavis, le contenu des renseignements et documents publiés sur le site.
            </p>
            <p>
              Par ailleurs, la responsabilité de l’Editeur ne peut être engagée en cas de défaillance, panne, difficulté ou interruption de fonctionnement, empêchant l'accès au site ou à une de ses fonctionnalités.
            </p>
            <p>
              Le matériel de connexion au présent site que vous utilisez est sous votre entière responsabilité. Vous devez prendre toutes les mesures appropriées pour protéger votre matériel et vos propres données notamment d'attaques virales par Internet.
            </p>
            <p>
              Vous êtes par ailleurs le seul responsable des sites et données que vous consultez.
            </p>

            <h2>
              Liens hypertextes
            </h2>
            <p>
              L’Éditeur peut proposer des liens depuis son Site vers d'autres sites.
              Ces sites sont indépendants, l’Éditeur ne les contrôle donc pas. Les liens vers tous sites
               ne constituent, en aucun cas, une approbation ou un partenariat entre l’Éditeur et ceux-ci.
               Dès lors, l’Éditeur ne saurait être responsable de leurs contenus, produits, publicités
               ou de tous éléments ou services qui y seraient présentés. Ces sites sont soumis à leurs
               propres conditions d'utilisation et de protection des données personnelles.
            </p>
            <p>
              Parallèlement, la mise en place d’un lien hypertexte vers son Site nécessite une autorisation préalable et écrite de l’Éditeur, sous réserve des dispositions légales en vigueur.
            </p>
            <p>
              L’Éditeur se réserve la possibilité, à tout moment, sans préavis et sans avoir à motiver sa décision, d’interdire un lien.
              En tout état de cause, l’Éditeur ne peut être tenu pour responsable ni du contenu ni des produits ou services proposés sur les sites auxquels son Site serait lié.
            </p>

            <h2>
              Informatiques et libertés, Protection des données personnelles
            </h2>
            <p>
              L’Éditeur ne recueille aucune donnée à caractère personnel sur le présent. <br>
              Ce site utilise Google Analytics pour mesurer le trafic et l’audience du site, si vous y avez consenti lors de votre première visite.
            </p>

            <h2>
              Droit applicable
            </h2>
            <p>
              L'accès au présent site, sa consultation et son utilisation, sont régis par le droit français.
            </p>

            <h2>
              Politique de Cookies
            </h2>
            <p>
              Ce site utilise des cookies dans le but de vous permettre d’économiser votre temps.
            </p>
            <p>
              De manière générale, ils enregistrent des informations relatives à la navigation de votre ordinateur sur notre site (les pages que vous avez consultées, la date et l'heure de la consultation, etc.) que nous pourrons lire lors de vos visites ultérieures.
            </p>
            <p>
              Nous utilisons aussi des cookies de mesure de l'audience émis par nous ou par nos prestataires techniques. Outre l'analyse de fréquentation, ils permettent, le cas échéant, de détecter des problèmes de navigation et par conséquent d’améliorer l’ergonomie de nos services.
            </p>
            <p>
              Les services d’analyses de fréquentation utilisés par ce site ne produisent et n’adressent à AUDAS PRO et à nos prestataires techniques que des statistiques agrégées et des volumes de fréquentation, à l’exclusion de toute information individuelle. Ils ne permettent pas de suivre votre navigation sur d’autres sites.
            </p>
            <p>
              La durée de vie de ces Cookies de mesure d’audience n’excède pas 24 mois.
            </p>
            <p>
              Si vous ne souhaitez pas que notre site enregistre le cookie dans votre navigateur à des fins de mesure d’audience (Google Analytics), vous pouvez cliquer sur les liens de désactivation suivants :
              <ul>
                <li>Google Analytics - http://www.google.com </li>
                <li>Lien de désactivation : https://tools.google.com/dlpage/gaoptout?hl=fr </li>
              </ul>
            </p>
            <p>
              Vous pouvez plus largement vous opposer à l'enregistrement des cookies en configurant votre navigateur :
              <ul>
                <li>
                  Pour Internet Explorer (TM) : http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies
                </li>
                <li>
                  Pour Safari (TM) : http://support.apple.com/kb/ht1677
                </li>
                <li>
                  Pour Chrome (TM) : http://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647
                </li>
                <li>
                  Pour Firefox (TM) : https://support.mozilla.org/fr/kb/autoriser-bloquer-cookies-preferences-sites
                </li>
                <li>
                  Pour Opera (TM) : http://help.opera.com/Windows/10.20/fr/cookies.html
                </li>
              </ul>
            </p>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import formTitleComponent from '@/components/formTitleComponent'

export default {
  name: 'About',
  components: {
    formTitleComponent,
  },
}
</script>
